import React, { useState } from "react";


import {
  FaBook,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function LegalCompliancePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Document Review & Contracting",
      points: [
        "Contract Clause Analyzer Agent",
        "Legal Document Summarization Agent",
        "NDA Auto-Drafting Agent",
        "Compliance Checklist Validator",
        "Risky Clause Identifier Agent",
      ],
    },

    {
      title: "Research & Case Intelligence",
      points: [
        "Case Law Retrieval Agent",
        "Legal Precedent Suggestion Agent",
        "Opponent Strategy Predictor",
        "Legal Argument Generator",
        "IP Rights Expiry Monitor Agent",
      ],
    },

    {
      title: "Litigation & Dispute Resolution",
      points: [
        "Court Hearing Scheduler Agent",
        "Witness & Evidence Tracker Agent",
        "Dispute Pattern Analyzer Agent",
        "Argument Outcome Predictor",
        "Compliance Violation Detector Agent",
      ],
    },

    {
      title: "Internal Corporate Compliance",
      points: [
        "Internal Audit Tracker Agent",
        "Fraud Risk Alert Bot",
        "Anti-Money Laundering (AML) Agent",
        "Employee Ethics Violation Detector",
        "Insider Trading Pattern Agent",
      ],
    },

    {
      title: "Client Engagement & CRM",
      points: [
        "Client Intake Chatbot",
        "Case Progress Update Agent",
        "Invoice & Billing Dispute Bot",
        "E-signature & Validation Agent",
        "Document Upload Validator",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .legal-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .legal-hero {
          background: #173b8f;
          width: 100%;
        }

        .legal-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .legal-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .legal-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .legal-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .legal-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .legal-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .legal-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .legal-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .legal-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .legal-card-header.active {
          background: #173b8f;
        }

        .legal-card-header.inactive {
          background: #ffffff;
        }

        .legal-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .legal-card-title.active {
          color: #ffffff;
        }

        .legal-card-title.inactive {
          color: #173b8f;
        }

        .legal-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .legal-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .legal-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .legal-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .legal-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .legal-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .legal-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .legal-hero-inner {
            padding: 32px 0px;
          }

          .legal-title {
            font-size: 30px;
          }

          .legal-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .legal-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .legal-icon-box {
            width: 40px;
            height: 40px;
          }

          .legal-icon-box svg {
            font-size: 18px;
          }

          .legal-title {
            font-size: 26px;
          }

          .legal-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .legal-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .legal-card-header {
            padding: 12px 16px;
          }

          .legal-card-title {
            font-size: 15px;
          }

          .legal-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .legal-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .legal-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .legal-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .legal-icon-box svg {
            font-size: 16px;
          }

          .legal-title {
            font-size: 21px;
          }

          .legal-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .legal-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .legal-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .legal-card-header {
            padding: 10px 14px;
          }

          .legal-card-title {
            font-size: 14px;
          }

          .legal-card-content {
            padding: 14px 14px;
          }

          .legal-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .legal-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .legal-point-check svg {
            font-size: 9px;
          }

          .legal-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .legal-title {
            font-size: 18px;
          }

          .legal-card-title {
            font-size: 13px;
          }

          .legal-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="legal-wrapper">
        {/* HERO SECTION */}
        <div className="legal-hero">
          <div className="legal-hero-inner">
            <div className="legal-hero-top">
              <div className="legal-icon-box">
                <FaBook />
              </div>

              <h1 className="legal-title">Legal & Compliance</h1>
            </div>

            <p className="legal-description">
              This sector includes law firms, legal departments, and regulatory bodies managing contracts, litigation, governance, and regulatory adherence.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="legal-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="legal-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`legal-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`legal-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="legal-chevron-active" />
                  ) : (
                    <FaChevronDown className="legal-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="legal-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="legal-point-row">
                        <div className="legal-point-check">
                          <FaCheck />
                        </div>

                        <p className="legal-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default LegalCompliancePage;
